import { Route, Routes, Navigate } from 'react-router';
import LoginPage from '../pages/auth/LoginPage';
import { RecoveryPasswordPage } from '../pages/auth/RecoveryPasswordPage';
import { RegisterPage } from '../pages/auth/RegisterPage';
import { RegisterWithPage } from '../pages/auth/RegisterWithPage';

export const AuthRouter = (
    {
        isAuthenticated
    }
) => {

    if (isAuthenticated) {
        return (
            <Navigate to="/" />
        )
    }

    return (
        <Routes>
            <Route path="/" element={<RegisterWithPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registro" element={<RegisterPage />} />
            <Route path="/recuperar" element={<RecoveryPasswordPage />} />
        </Routes>
    )
}
